import React from 'react';
import cn from 'classnames';
import { Badge, Button, DropdownMenu, IconButton, Skeleton, Typography } from 'seagull';
import styles from "./PaymentMethodPanel.module.scss";
import { MoreVertical, TrashLiner24 } from 'seagull/icons';
export default function PaymentMethodPanel(props) {
  const {
    isSelected,
    removable,
    selectable,
    logo,
    title,
    description,
    footer,
    isMobile,
    onSelect,
    onRemove
  } = props;
  const RootElement = isMobile ? 'button' : 'div';
  return /*#__PURE__*/React.createElement(RootElement, {
    className: cn(styles.paymentMethod, {
      [styles.selected]: isSelected,
      [styles.isMobile]: isMobile
    }),
    "data-testid": "manage-payment-methods-payment-method",
    onClick: selectable && isMobile ? onSelect : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, logo), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "light"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "manage-payment-methods-payment-method-details",
    variant: "paragraph1",
    weight: "light",
    skin: "secondary"
  }, description)), isSelected ? /*#__PURE__*/React.createElement(Badge, {
    className: styles.selectedBadge,
    rounded: true,
    outlined: true,
    skin: "primary",
    "data-testid": "manage-payment-methods-payment-method-selected"
  }, "Selected") : selectable && !isMobile && /*#__PURE__*/React.createElement(Button, {
    className: styles.selectBtn,
    "data-testid": "payment-method-select-btn",
    skin: "primaryOutline",
    size: "small",
    onClick: onSelect
  }, "Select for this agreement")), removable && /*#__PURE__*/React.createElement(DropdownMenu, {
    target: /*#__PURE__*/React.createElement(IconButton, {
      className: styles.removeBtn,
      skin: "transparent",
      "data-testid": "payment-method-dropdown"
    }, /*#__PURE__*/React.createElement(MoreVertical, null))
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    skin: "error",
    iconStart: /*#__PURE__*/React.createElement(TrashLiner24, null),
    "data-testid": "payment-method-remove-btn",
    onClick: onRemove
  }, "Remove")), footer && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer));
}
export function PaymentMethodPanelSkeleton(_ref) {
  let {
    isMobile
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.paymentMethod, {
      [styles.isMobile]: isMobile
    }),
    "data-testid": "manage-payment-methods-payment-method-skeleton"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 42,
    width: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "light"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 35,
    width: "100%",
    style: {
      marginBottom: 8
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "manage-payment-methods-payment-method-details",
    variant: "paragraph1",
    weight: "light",
    skin: "secondary"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "100%"
  })))));
}